import { CommonModule, CurrencyPipe } from '@angular/common';
import { DscrComponent } from 'ng2-app/components/dscr/dscr.component';
import {
  DynamicScreenHeightModule
} from 'ng2-app/modules/directives/dynamic-screen-height/dynamic-screen-height.module';

import { StatusDisplayModule } from 'ng2-app/pipes/status-display/status-display-pipe.module';
import { PhoneModule } from 'ng2-app/pipes/phone/phone-pipe.module';

import { NgModule } from '@angular/core';
import { DocumentService } from 'ng2-app/modules/borrower/models/document/document.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

// tabs
import { BorrowerDetailTabsComponent } from 'ng2-app/modules/borrower/components/borrower-details/borrower-detail-tabs/borrower-detail-tabs.component';
import { BorrowerActivityStreamModule } from 'ng2-app/modules/borrower/components/borrower-details/borrower-detail-tabs/borrower-activity-stream/borrower-activity-stream.module';
import { BorrowerDocumentsModule } from 'app/documents/documents.module';
import { BorrowerOverviewModule } from 'app/borrower-overview/borrower-overview.module';
import { BorrowerCreditModule } from 'app/borrower-credit/borrower-credit.module';
import { BorrowerFinancesModule } from 'app/borrower-finances/borrower-finances.module';

// Borrower overview components
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { ScheduleReminderModule } from 'app/schedule-reminder/schedule-reminder.module';
import { DealModule } from 'app/deal/deal.module';
import { MessagesModule } from 'app/messages/messages.module';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PartnerRestrictionModule } from 'app/partner-restriction/partner-restriction.module';
import { ShareBorrowerModule } from 'app/borrower-header/share-borrower/share-borrower.module';
import { ClaimBorrowerModule } from 'app/borrower-header/claim-borrower/claim-borrower.module';
import { ChangeAssignmentSmartModule } from 'app/borrower-header/change-assignment-smart/change-assignment-smart.module';
import { ComplianceReviewDialogModule } from 'app/borrower-header/compliance-review-dialog/compliance-review-dialog.module';
import { CallButtonModule } from 'app/borrower-header/call-button/call-button.module';
import { BorrowerComplaintModule } from 'app/borrower-header/borrower-complaint/borrower-complaint.module';
import { ActivityModule } from 'app/modules/activity/activity.module';
import { ActivityViewsService } from 'app/modules/funnel/models/activity-view.service';
import { RouterModule } from '@angular/router';
import { CautionBarModule } from 'app/borrower-fd/borrower-fd-view/caution-bar/caution-bar.module';
import { RequestConfirmationDialogComponent } from 'lendio-borrower/components/borrower-details/workflow/request/confirm-dialog/request-confirmation-dialog.component';
import { RequestConfirmationEditDialogComponent } from 'lendio-borrower/components/borrower-details/workflow/request/confirm-dialog-edit/request-confirmation-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { ErcApplicationModule } from 'ng2-app/erc-application/erc-application.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    BorrowerActivityStreamModule,
    BorrowerDocumentsModule,
    BorrowerOverviewModule,
    CallButtonModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    PhoneModule,
    ReactiveFormsModule,
    FormlyModule.forChild(),
    FormlyMaterialModule,
    StatusDisplayModule,
    MatDividerModule,
    MatTabsModule,
    MatMenuModule,
    MatButtonModule,
    MatSnackBarModule,
    TruncateModule,
    ScheduleReminderModule,
    DealModule,
    MessagesModule,
    MatIconModule,
    MatTooltipModule,
    PartnerRestrictionModule,
    MatProgressSpinnerModule,
    ShareBorrowerModule,
    ClaimBorrowerModule,
    ChangeAssignmentSmartModule,
    ComplianceReviewDialogModule,
    BorrowerComplaintModule,
    ActivityModule,
    RouterModule,
    CautionBarModule,
    BorrowerCreditModule,
    BorrowerFinancesModule,
    ErcApplicationModule,
    DscrComponent,
    DynamicScreenHeightModule
  ],
    declarations: [
        BorrowerDetailTabsComponent,
        RequestConfirmationDialogComponent,
        RequestConfirmationEditDialogComponent
    ],
    providers: [
        { provide: Window, useValue: window },
        CurrencyPipe,
        DocumentService,
        ActivityViewsService
    ],
    exports: [
        BorrowerDetailTabsComponent,
    ]
})
export class BorrowerDetailsModule { }
